// extracted by mini-css-extract-plugin
module.exports = {"terms":"Checkbox_terms__r16Hu","description":"Checkbox_description__MsHJ7","checkbox":"Checkbox_checkbox__dVHAC"};